import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";
import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ADIColors from "@NA/Utils/ADIColors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const catalogSettings = state.context.settings.settingsCollection.catalogSettingSettings as any;
    return {
        catalogSettings,
    };
};

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

export interface ADIProductDetailsOverviewStyles {
    wrapper?: InjectableCss;
    wrapperCondensed?: InjectableCss;
    wrapperCondensedMkt?: InjectableCss;
    overViewTitle?: InjectableCss;
    mainFeatures?: InjectableCss;
    showLessLinkWrapper?: InjectableCss;
    showLessLink?: LinkPresentationProps;
    generalInformation?: InjectableCss;
}

export const adiProductDetailsOverviewStyles: ADIProductDetailsOverviewStyles = {
    wrapper: {
        css: css`
            margin-bottom: 15px;
            margin-top: 15px;
            height: auto;
            transition: height 0.4s linear;
            .titleText {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                margin-bottom: 6px;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
    wrapperCondensed: {
        css: css`
            margin-bottom: 15px;
            height: 136px;
            overflow: hidden;
            transition: height 0.4s linear;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            height: 100px;
                        `,
                    ],
                    "max",
                )}
            .titleText {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                margin-bottom: 6px;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
    wrapperCondensedMkt: {
        css: css`
            margin-bottom: 15px;
            height: 500px;
            overflow: hidden;
            transition: height 0.4s linear;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            height: 100px;
                        `,
                    ],
                    "max",
                )}
            .titleText {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                margin-bottom: 6px;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
    overViewTitle: {
        css: css`
        
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 10px;
                        font-size:12px;
                    `,
                    css`
                        padding-bottom: 10px;
                        font-size:12px;
                    `,
                    css`
                        padding-bottom: 10px;
                        font-size:12px;
                    `,
                    css`
                  
                    font-size:12px;
                `,
                    css`
                        padding: 0px 0px 10px 23px;
                    `,
                ])}

            > ${TypographyStyle} {
                line-height: 1.63;
                > ul {
                    list-style: disc;
                    padding-left: 40px;
                    margin: 1rem 0;
                }
            }
        `,
    },
    mainFeatures: {
        css: css`
            margin-left: 2.5em;
            padding-bottom: 10px;

            ul {
                list-style: disc;
                li {
                    line-height: 1.63;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    font-size:12px;
                    `,
                    css`
                    font-size:12px;
                    `,
                    css`
                       font-size:12px;
                    `,
                    css`
                   
                    `,
                    css`
                        
                    `,
                ])}
        `,
    },
    showLessLinkWrapper: {
        css: css`
            position: relative;
            margin-bottom: 20px;
            width: 100%;
            hr {
                border: solid ${ADIColors.gray2};
                border-width: 1px 0 0;
                clear: both;
                margin: 1.25rem 0 1.1875rem;
                height: 0;
                border-top: 1px solid ${ADIColors.gray2};
            }
        `,
    },
    showLessLink: {
        css: css`
            position: absolute;
            top: -10px;
            left: 45%;
            background: #fff;
            padding: 0 15px;
            font-weight: 800;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        left: 33%;
                    `,
                    css`
                        left: 42%;
                    `,
                    css`
                        left: 42%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    generalInformation: {
        css: css`
            font-size: 1rem;
            line-height: 1.63;
            padding-left: 1.5rem;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                       font-size:12px;
                    `,
                    css`
                    font-size:12px;
                    `,
                    css`
                    font-size:12px;
                    `,
                    css`
                    font-size:12px;
                    `,
                    null,
                ])}
        `,
    },
};

const styles = adiProductDetailsOverviewStyles;

const ADIProductDetailsOverview: React.FC<Props> = ({ product, catalogSettings }) => {
    const data = product.properties?.featureBullets1to10;    
    const [showLess, setShowLess] = React.useState(false);
    const [showAplusLess, setShowAplusLess] = React.useState(false);

    React.useEffect(() => {
        if (catalogSettings) {
            checkForAPlusContent();
        }
    }, [catalogSettings]);

    const checkForAPlusContent = () => {
        if (
            product &&
            catalogSettings.aPlusContentEnabled &&
            product.properties["aPlusContentId"] &&
            product.properties["aPlusContentId"] != ""
        ) {
            let myScript = document.createElement("script");
            myScript.setAttribute("data-spex-auth-key", catalogSettings.aPlusAuthKey);
            myScript.setAttribute("data-spex-profile-id", catalogSettings.aPlusProfileId);
            myScript.setAttribute("src", catalogSettings.aPlusSourceUrl);
            myScript.setAttribute("data-spex-etilize-product-id", product.properties["aPlusContentId"]);
            myScript.setAttribute("data-spex-sku-type", "");
            myScript.setAttribute("data-spex-sku-number", "");
            myScript.setAttribute("data-spex-mfg-name", "");
            myScript.setAttribute("data-spex-mfg-part-number", "");
            myScript.setAttribute("data-spex-on-product-found", "");
            myScript.setAttribute("data-spex-on-product-not-found", "");
            myScript.setAttribute("data-spex-overview-container-id", "aPlusOverview");
            myScript.setAttribute("data-spex-gallery-container-id", "");
            myScript.setAttribute("data-spex-specs-container-id", "");
            myScript.setAttribute("data-spex-brand-container-id", "");
            myScript.setAttribute("data-spex-360-view-container-id", "aPlus360");
            myScript.setAttribute("data-spex-videos-container-id", "");
            myScript.setAttribute("data-spex-override-style", "");
            myScript.setAttribute("data-spex-only-enhanced-content", "");
            myScript.setAttribute("data-spex-hide-powered-by", "true");
            myScript.setAttribute("data-spex-hide-social-media-icons", "true");
            myScript.setAttribute("data-spex-locale", "en_US");
            document.body.appendChild(myScript);
        }
    };

    if (!catalogSettings) {
        return null;
    }

    const isMkt_Info =
        product.properties["aPlusContentId"] === undefined ||
        product.properties["aPlusContentId"] == "" ||
        !catalogSettings.aPlusContentEnabled;

    const countryOfOrigin =
        product.properties && product.properties.countrY_OF_ORIGIN ? product.properties.countrY_OF_ORIGIN : "";

    return (
        <>
            <StyledWrapper {...(showLess ? { ...styles.wrapperCondensed } : { ...styles.wrapper })}>
                <Typography variant="h3" as="h3" data-test-selector="OverviewTitle" className="titleText">
                    {translate("Product Overview")}
                </Typography>
                {isMkt_Info && product.properties?.mkt_Info && product.properties?.mkt_Info != 'null' && (
                    <StyledWrapper {...styles.overViewTitle}>
                        {/* <Typography>{product.properties?.mkt_Info.toString().replace(/(<([^>]+)>)/gi, "")}</Typography> */}
                        <Typography dangerouslySetInnerHTML={{ __html: product.properties?.mkt_Info }} />
                    </StyledWrapper>
                )}
                {!isMkt_Info && (
                    <>
                        <StyledWrapper {...(showAplusLess ? { ...styles.wrapperCondensedMkt } : { ...styles.wrapper })}>
                            <StyledWrapper id="aPlusOverview"></StyledWrapper>
                            <StyledWrapper id="aPlus360"></StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper {...styles.showLessLinkWrapper}>
                            <hr />
                            <Link {...styles.showLessLink} onClick={() => setShowAplusLess(!showAplusLess)}>
                                Show {showAplusLess ? "More" : "Less"}
                            </Link>
                        </StyledWrapper>
                    </>
                )}
                {data && (
                    <>
                        <Typography variant="h3" as="h3" data-test-selector="OverviewTitle" className="titleText">
                            {translate("Main Features")}
                        </Typography>
                        <StyledWrapper {...styles.mainFeatures}>
                            <Typography dangerouslySetInnerHTML={{ __html: data }} />
                        </StyledWrapper>
                    </>
                )}

                <Typography variant="h3" as="h3" data-test-selector="OverviewTitle" className="titleText">
                    {translate("General Information")}
                </Typography>
                <StyledWrapper {...styles.generalInformation}>
                    <StyledWrapper>
                        <Typography data-test-selector="OverviewTitle">
                            {translate("Name: ")}
                            {product?.detail?.name}
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography data-test-selector="OverviewTitle">
                            {translate("Category: ")}
                            {product.properties.productcategoryList}
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography data-test-selector="OverviewTitle">
                            {translate("UPC Code: ")}
                            {product?.detail?.upcCode}
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Typography data-test-selector="OverviewTitle">
                            {translate("Country of Origin: ")}
                            {`${countryOfOrigin}. Country of origin is subject to change.`}
                        </Typography>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.showLessLinkWrapper}>
                <hr />
                <Link {...styles.showLessLink} onClick={() => setShowLess(!showLess)}>
                    Show {showLess ? "More" : "Less"}
                </Link>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ADIProductDetailsOverview)),
    definition: {
        displayName: "ADI Overview",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
